export const encodeState = (state: { [key: string]: any }, shouldUrlEncode: boolean = false) => {
  const b64state = btoa(JSON.stringify(state))
  return shouldUrlEncode ? encodeURIComponent(b64state) : b64state
}

export const decodeState = (b64state: string): { [key: string]: any } => {
  const json = atob(b64state)
  return JSON.parse(json)
}

export function addToState(state: string | null, keyName: string, value: any): string {
  try {
    let decoded: { [key: string]: any }
    if (!state) {
      decoded = { [keyName]: value }
    } else {
      decoded = decodeState(state)
      decoded[keyName] = value
    }
    return encodeState(decoded)
  } catch {
    return state || ''
  }
}

const TRUSTED_REDIRECT_HOST = 'zocks.io'

export const isSafeRedirect = (url?: string | null): boolean => {
  if (!url) {
    return false
  }
  if (url.startsWith('//') || url.startsWith('\\')) {
    return false
  }
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') {
      return false
    }
    const host = parsed.hostname.toLowerCase()
    return host === TRUSTED_REDIRECT_HOST || host.endsWith(`.${TRUSTED_REDIRECT_HOST}`)
  } catch {
    return false
  }
}

export const toStateRedirect = (url: string | null): string | null => (url && isSafeRedirect(url) ? new URL(url).href : null)

const APP_PATHS = ['/dashboard', '/enterprise-dashboard', '/console']

export const toCurrentOrigin = (url: string): string => {
  try {
    const target = new URL(url, window.location.href)
    const { hostname, origin } = window.location
    const baseDomain = hostname.substring(hostname.indexOf('.') + 1)
    const isSibling = target.hostname !== hostname && target.hostname.endsWith(`.${baseDomain}`)
    const isAppPath = APP_PATHS.some((path) => target.pathname === path || target.pathname.startsWith(`${path}/`))
    return isSibling && isAppPath ? `${origin}${target.pathname}${target.search}${target.hash}` : url
  } catch {
    return url
  }
}
